import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { resolveDocumentTitle } from '@/utils/documentTitle';

export default function DocumentTitleSync() {
  const { pathname, search } = useLocation();
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language;

  useEffect(() => {
    document.title = resolveDocumentTitle(pathname, search);
  }, [pathname, search, language]);

  return null;
}
